module.exports = __webpack_public_path__ + "img/srilanka.223d4382.svg";